import { Component, Input } from '@angular/core';
import { QuillViewHTMLComponent } from 'ngx-quill';
import { NgClass } from '@angular/common';

@Component({
    selector: 'slm-editor-presenter',
    template: `
    <quill-view-html
      [content]="content"
      class="overflow-hidden block pos-relative"
      [ngClass]="{ 'border radius-big': !hideBorder }"
    ></quill-view-html>
  `,
    imports: [QuillViewHTMLComponent, NgClass]
})
export class EditorPresenterComponent {
  @Input() public content = '';
  @Input() public hideBorder = false;
}
